import { render, staticRenderFns } from "./ProfileProfessionalForm.vue?vue&type=template&id=60cb7d0b&scoped=true"
import script from "./ProfileProfessionalForm.vue?vue&type=script&lang=js"
export * from "./ProfileProfessionalForm.vue?vue&type=script&lang=js"
import style0 from "./ProfileProfessionalForm.vue?vue&type=style&index=0&id=60cb7d0b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60cb7d0b",
  null
  
)

export default component.exports